/* Progressive enhancement; commerce is handled by Shopify's native theme components. */
document.addEventListener('click', event => {
  const view = event.target.closest('[data-vh-view]');
  if (view) {
    const active = view.getAttribute('aria-pressed') !== 'true';
    view.setAttribute('aria-pressed', String(active));
    view.closest('.vh-product__media').classList.toggle('is-alternate', active);
  }
  const filter = event.target.closest('[data-filter]');
  if (!filter) return;
  const region = filter.closest('[data-vh-filter]');
  if (!region) return;
  region.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
  let count = 0;
  region.querySelectorAll('[data-category]').forEach(card => {
    card.hidden = filter.dataset.filter !== 'All' && card.dataset.category !== filter.dataset.filter;
    if (!card.hidden) count++;
  });
  region.querySelector('[data-filter-status]').textContent = `${count} collection previews shown.`;
});

document.addEventListener('change', event => { if (event.target.matches('[data-vh-currency]')) event.target.form.requestSubmit(); });

// A table of contents built from the policy's existing headings; policy text stays intact.
const policy = document.querySelector('.shopify-policy__container');
if (policy) {
 const headings = [...policy.querySelectorAll('.shopify-policy__body h2')];
 if (headings.length) {
  const nav = document.createElement('nav'); nav.className='vh-policy-nav'; nav.setAttribute('aria-label','On this page');
  headings.forEach((heading,index)=>{if(!heading.id) heading.id=`policy-section-${index+1}`; const link=document.createElement('a');link.href=`#${heading.id}`;link.textContent=heading.textContent;nav.append(link);});
  policy.insertBefore(nav,policy.firstChild);
 }
}

// Native currency disclosure: dismiss without changing the selected market.
document.addEventListener('click', event => { document.querySelectorAll('.vh-currency-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; }); });
document.addEventListener('keydown', event => { if(event.key === 'Escape') document.querySelectorAll('.vh-currency-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); }); });

// A real touch/keyboard control, separate from the product link.
document.addEventListener('click', event => {
  const button = event.target.closest('[data-vh-turn]');
  if (!button) return;
  event.preventDefault();
  event.stopPropagation();
  const card = button.closest('[data-vh-card]');
  const showingBack = button.getAttribute('aria-pressed') !== 'true';
  button.setAttribute('aria-pressed', String(showingBack));
  button.setAttribute('aria-label', `Show ${showingBack ? 'front' : 'back'} of ${button.dataset.title}`);
  button.querySelector('[data-vh-turn-label]').textContent = showingBack ? 'View front' : 'View back';
  card.classList.toggle('is-back', showingBack);
  card.dataset.manual = 'true';
}, true);
// Open the existing product details before navigating to fit and care information.
document.addEventListener('click', event => {
 const link=event.target.closest('[data-vh-details-link]');
 if(!link) return;
 const details=document.getElementById('VouhtiProductDetails');
 if(details) details.open=true;
});
